import { RouteName } from '@lib/types';

import { GetDefaultlScreen } from './types';

type ScreenPathRegex = {
  [K in RouteName]: RegExp;
};

const screenPathEegex: ScreenPathRegex = {
  NewOrders: /\/orders\/new/,
  NewOrder: /\/orders\/new\/[a-z-]+/i,
  AcceptedOrders: /\/orders\/accepted/,
  AcceptedOrder: /\/orders\/accepted\/[a-z-]+/i,
  OrdersHistory: /\/orders\/history/,
  OrderHistory: /\/orders\/history\/[a-z-]+/i,
  Trips: /\/trips/,
  Menu: /\/menu/,
};

export const getDefaultScreen: GetDefaultlScreen = () => {
  const { pathname } = window.location;
  const [screen] =
    Object.entries(screenPathEegex).find(([, regex]) => regex.test(pathname)) ||
    [];

  return (screen || 'NewOrders') as RouteName;
};
